<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [showHeader]="false"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="global-search-dialog"
  [style]="{ width: '600px' }"
  (onHide)="close()"
  [position]="'top'"
  >
  <div class="global-search-container">
    <div class="search-input-wrapper">
      <i class="ri-search-line search-icon"></i>
      <input
        #searchInput
        type="text"
        class="search-input"
        [value]="query"
        (input)="onInput($event)"
        (keydown)="onKeydownInInput($event)"
        i18n-placeholder="@@global-search-placeholder"
        placeholder="Bots, Projekte oder Dokumente suchen…"
        autocomplete="off"
        />
      <span class="search-shortcut">
        <kbd>ESC</kbd>
      </span>
    </div>

    @if (hasQuery) {
      <div
        class="search-results"
        >
        <!-- Loading -->
        @if (loading) {
          <div
            class="search-loading"
            >
            <i class="ri-loader-4-line ri-spin"></i>
            <span i18n="@@global-search-loading">Suche läuft…</span>
          </div>
        }
        <!-- Results -->
        @if (!loading && results) {
          <div>
            <!-- No results -->
            @if (!hasResults) {
              <div
                class="search-empty"
                >
                <i class="ri-search-line"></i>
                <span i18n="@@global-search-no-results">Keine Ergebnisse für „{{query}}" gefunden</span>
              </div>
            }
            <!-- Projects -->
            @if (results.projects.length > 0) {
              <div
                class="result-group"
                >
                <div
                  class="result-group-header"
                  i18n="@@global-search-projects"
                >Projekte</div>
                @for (project of results.projects; track project; let i = $index) {
                  <div
                    class="result-item"
                    [class.selected]="isSelected(getItemIndex('project', i))"
                    (click)="selectItem({ type: 'project', data: project })"
                    (mouseenter)="selectedIndex = getItemIndex('project', i)"
                    >
                    <i class="ri-folder-line result-icon project-icon"></i>
                    <div class="result-content">
                      <span class="result-name">{{ project.name }}</span>
                      <span class="result-meta">{{ project.orgShort }}</span>
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Bots -->
            @if (results.bots.length > 0) {
              <div
                class="result-group"
                >
                <div
                  class="result-group-header"
                  i18n="@@global-search-bots"
                >Bots</div>
                @for (bot of results.bots; track bot; let i = $index) {
                  <div
                    class="result-item"
                    [class.selected]="isSelected(getItemIndex('bot', i))"
                    (click)="selectItem({ type: 'bot', data: bot })"
                    (mouseenter)="selectedIndex = getItemIndex('bot', i)"
                    >
                    <i class="ri-robot-2-line result-icon bot-icon"></i>
                    <div class="result-content">
                      <span class="result-name">{{ bot.name }}</span>
                      @if (bot.projectName) {
                        <span
                          class="result-meta"
                        >{{ bot.projectName }}</span>
                      }
                      @if (bot.creatorName) {
                        <span
                          class="result-meta"
                        > · {{ bot.creatorName }}</span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Documents -->
            @if (results.documents.length > 0) {
              <div
                class="result-group"
                >
                <div
                  class="result-group-header"
                  i18n="@@global-search-documents"
                >Dokumente</div>
                @for (doc of results.documents; track doc; let i = $index) {
                  <div
                    class="result-item"
                    [class.selected]="isSelected(getItemIndex('document', i))"
                    (click)="selectItem({ type: 'document', data: doc })"
                    (mouseenter)="selectedIndex = getItemIndex('document', i)"
                    >
                    <i class="ri-file-text-line result-icon doc-icon"></i>
                    <div class="result-content">
                      <span class="result-name">{{ doc.filename }}</span>
                      <span class="result-meta">{{ doc.projectName }}</span>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Empty state -->
    @if (!hasQuery) {
      <div
        class="search-hint"
        >
        <span i18n="@@global-search-hint">Suche nach Bots, Projekten oder Dokumenten</span>
      </div>
    }
  </div>
</p-dialog>
